import { RootState } from "@/store/store";
import { savingsOpportunityCurrentViewSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunityCurrentViewSelector";

export const savingsOpportunityCurrentViewProtectedSelector = (
  state: RootState,
) => {
  const view = savingsOpportunityCurrentViewSelector(state);
  return view?.protection_details?.is_protected;
};
